// @flow weak

import { withProps } from 'recompose';

import MountUnmount from 'app/common/components/MountUnmount';

const createMountUnmount = (onMount, onUnmount) => {
  return withProps({ onMount, onUnmount })(MountUnmount);
};

export default createMountUnmount;
